import React, { useContext, useState } from 'react';
import MixpanelConfig from '../../../_shared/constants/mixpanelConfig';
import DocumentsOwingModal from './DocumentsOwingModal';
import PaymentsOnHoldContext from '../Context';
import PaymentsOnHoldListItem from './Item';
import Placeholder from './Placeholder';
import Pagination from '../Pagination';
import StyledListWrapper from './Styles';
import PaymentsOnHoldUploadDocModalContainer from '../../Modal/PaymentsOnHoldUploadDocModalContainer';
import useAnalytics from '../../../_shared/hooks/useAnalytics';
import SegmentConfig from '../../../_shared/constants/segmentConfig';
import capitalizeFirstLetter from '../../../_shared/utils/capitalizeFirstLetter';
import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

const List = ({ handleNavigateToTradeUri }) => {
  const [tradeDocOwingModal, setTradeDocOwingModal] = useState(null);
  const [tradeDocUploadModal, setTradeDocUploadModal] = useState(null);
  const [modalStatusKey, setModalStatusKey] = useState(null);
  const { trades, currentPage } = useContext(PaymentsOnHoldContext);
  const track = useAnalytics();

  const onClickDocumentOwning = (trade, statusKey) => {
    const infoClicked = `${trade.onHoldStatuses
      .find(item => item.key === statusKey)
      .key.replace(/_/g, ' ')} needed for funding`;

    if (isOmpPlatform()) {
      track(SegmentConfig.names.paymentsOnHoldViewDocumentsOwing, {
        document_type: capitalizeFirstLetter(statusKey)
      });
    } else {
      track(MixpanelConfig.names.viewDocumentsOwing, {
        source: infoClicked
      });
    }

    setTradeDocOwingModal(trade);
    setModalStatusKey(statusKey);
  };

  const onClickDocumentUpload = (trade, statusKey) => {
    setTradeDocUploadModal(trade);
    setModalStatusKey(statusKey);
  };

  const handleCloseDocOwingModal = () => {
    setTradeDocOwingModal(null);
    setModalStatusKey(null);
  };

  const handleCloseDocUploadModal = () => {
    setTradeDocUploadModal(null);
    setModalStatusKey(null);
  };

  return (
    <StyledListWrapper data-testid="payments-on-hold-list-wrapper">
      {currentPage > 1 && <Pagination />}
      {trades?.tradeSummaries?.length > 0 && (
        <>
          {trades?.tradeSummaries?.map(trade => (
            <PaymentsOnHoldListItem
              trade={trade}
              key={trade.id}
              onClickDocumentOwning={onClickDocumentOwning}
              onClickDocumentUpload={onClickDocumentUpload}
              handleNavigateToTradeUri={handleNavigateToTradeUri}
            />
          ))}
          <PaymentsOnHoldUploadDocModalContainer
            trade={tradeDocUploadModal}
            statusKey={modalStatusKey}
            onClose={handleCloseDocUploadModal}
          />
          <DocumentsOwingModal
            trade={tradeDocOwingModal}
            statusKey={modalStatusKey}
            onClose={handleCloseDocOwingModal}
          />
          <Pagination />
        </>
      )}
      {trades?.tradeSummaries?.length === 0 && <Placeholder />}
    </StyledListWrapper>
  );
};

export default List;
